import { render, staticRenderFns } from "./userLayout.vue?vue&type=template&id=4a386972&"
import script from "./userLayout.vue?vue&type=script&lang=js&"
export * from "./userLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports